import styled from "styled-components";

export const CompetitionTournamentHeader = styled.div`
  padding: 20px 16px 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;

  > .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    > .title {
      color: var(--kakao-logo, #000);

      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 25.771px; /* 128.857% */
    }

    > .date-box {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 5px;
    }
  }
`;

export const CompetitionTournamentSelector = styled.div`
  padding: 9px 8px 9px 12px;
  border-radius: 15px;
  border: 1px solid var(--Black-200, #b7b7b7);
  gap: 2px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  > .value {
    color: var(--Black-500, #202020);

    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > img {
    width: 14px;
    height: 14px;
  }
`;

export const CompetitionTournamentTypeWrapper = styled.div`
  width: 100%;
  padding: 5px 5.5px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  border-radius: 18px;
  background: #f0f0f0;

  > .item {
    padding: 8px 0px;
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--Black-200, #b7b7b7);

    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  > .item.active {
    border-radius: 15px;
    border: 1px solid #6436e7;
    background: #6436e7;
    color: #fff;
  }
`;
